export default {
  SET_LEARN_INFO: '[mine] set learn info',
  SET_COUPON: '[mine] set coupon',
  SET_COURSE: '[mine] set course',
  SET_SEND_COURSES: '[mine] set send courses'
}
